// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5l-1";
export var standaloneTable = "_5l-0";